import { jsx as _jsx } from "react/jsx-runtime";
import { StoresItem } from "@bluframe/mightychroma-mightytool-ui";
const Item = (props) => _jsx(StoresItem, { ...props });
export default Item;
